/**

wd-button is a button with optional display, left-icon, right-icon, tooltip, callback function

wd-link is a link with optional display, left-icon, right-icon, tooltip, callback function

wd-action is an icon-link with either icon or action, tooltip, callback function. (if you give both action and icon, icon will override action)

**/

(function () {
    'use strict';

    angular.module('GorillaBoy')

     .directive('wdButton', ['SourceConstant', function(SourceConstant) {
              return {
                    restrict: 'E',
                    templateUrl: './common/templates/wd-button.html',
                    scope : {
                       name: '=',
                       display : '@',
                       leftIcon : '@',
                       rightIcon : '@',
                       tooltip : '@',
                       callback : '&'
                    }
                };
      }])

      .directive('wdLink', ['SourceConstant', function(SourceConstant) {
            return {
                  restrict: 'E',
                  templateUrl: './common/templates/wd-link.html',
                  scope : {
                     name: '=',
                     display : '@',
                     leftIcon : '@',
                     rightIcon : '@',
                     tooltip : '@',
                     cssClass : '@',
                     href : '@',
                     callback : '&',
                     headCount : '@',
                     headActive : '@',
                     active : '='
                  },
                  transclude : true
              };
     }])

      .directive('wdAction', ['SourceConstant', function(SourceConstant) {
            return {
                  restrict: 'E',
                  require: '^wdActionBar',
                  templateUrl: './common/templates/wd-action.html',
                  scope : {
                      name: '=',
                     action : '@',
                     icon : '@',
                     tooltip : '@',
                     callback : '&',
                     textClass: '@' ,
                     class: '@'
                  }
              };
       }])

     .directive('wdActionBar', ['SourceConstant', function(SourceConstant) {
          return {
                name: '=',
                restrict: 'E',
                template: '<div ng-transclude></div>',
                transclude: true,
                scope : {
                    name: '=',
                   tooltip : '@',
                   callback : '&'
                }
            };
      }])



    ;
}());
